//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import numeric from "@/components/numeric";
import { mapActions, mapState } from "vuex";

export default {
  props: {
    article: {},
  }, 
  components: { numeric
    
  },
    
  data() {
    return {
      dense: true,
      priceCalculations: []
    };
  },

  async mounted() {
    this.priceCalculations = await this.getPriceCalcultaion();
  },

  computed: {
    ...mapState("main", []),
  },

  methods: {
    ...mapActions("main", ["getPriceCalcultaion"]),
  },
};
